import React, { useState } from 'react';
import {sendEventToGA} from "./../utils.js";
import {Link} from "react-router-dom";


/**
 * React component that consists of widgets that individually can be expanded (or collapsed) to reveal (or hide) their content
 *
 * @param prop.items An array of objects that is be used to populate accordion. Each object should contain "title" and "contents" fields. "span" field is optional
 * @return JSX
 */
export function Accordion(props) {
    let {items} = props;
    const [expandedIndex, setExpandedIndex] = useState(null);

    const toggleAccordion = (index) => {
        setExpandedIndex(index === expandedIndex ? null : index);
    };

    const handleTopicClick = (topic) => {
        sendEventToGA(`footer__accordian_topics__button`, 'footer-topics' , topic);
    }

    return (
        <div className={"accordion " + props.className}>
            {items.map((item, index) => (
                <div key={index} className= "accordion-item">
                    <div className="accordion-title" onClick={() => toggleAccordion(index)}>
                        <h2>{item.title}</h2>
                    </div>
                    {expandedIndex === index && (
                        <div className="accordion-content">
                          <div className={` ${item.contents && item.contents[0].span ? "itemListColumn":"itemListColumnPlain"}`}>
                            {item.contents.map((item, i) =>(
                               <div key={i} className={item.span?"itemSpanButton":"itemNonSpanButton"}>
                                 <button className="itemButton">
                                    {item.link && <Link to={item.link} onClick={()=>handleTopicClick(item.link)}>{item.text}</Link>}
                                    {item.email && <a href={`mailto:${item.email}`}>{item.text}</a>}
                                  </button>
                               </div>))}
                          </div>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};
